<div style="margin: 20px">
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
    <div
      class="workflow-node__card"
      [ngClass]="isSettingsFormValid ? 'workflow-node__card--valid' : 'workflow-node__card--invalid'"
    >
      <div class="workflow-node__status-icon">
        <mat-icon
          [matTooltip]="statusMessage"
          [ngClass]="{
            'workflow-node__status-no-execution-yet': !isExecuted,
            'workflow-node__status-icon-error': hasError && isExecuted,
            'workflow-node__status-icon-executed': isExecuted && !hasError,
          }"
          matTooltipClass="workflow-node__status-icon-custom-tooltip"
        >
          {{ !isExecuted ? 'hourglass_empty' : hasError ? 'priority_high' : 'check' }}
        </mat-icon>
      </div>
      <header #nodeHead fDragHandle>
        <mat-icon class="workflow-node__icon" [ngClass]="{ 'workflow-node__icon-minimized': isContentMinimized }"
          >{{ model.icon }}
        </mat-icon>
        <div *ngIf="!isContentMinimized" class="workflow-node__info">
          <span class="workflow-node__title">
            {{ model.name }}
          </span>
          <span class="workflow-node__description">{{ model.description }}</span>
        </div>
      </header>

      <footer>
        <div
          *ngFor="let output of outputs"
          fNodeOutput
          [fOutputConnectableSide]="eFConnectableSide.BOTTOM"
          [fOutputId]="output"
          [fOutputMultiple]="false"
          [isSelfConnectable]="false"
        ></div>

        <mat-icon class="workflow-node__add-action" (click)="onActionClicked($event)">add</mat-icon>
      </footer>
    </div>
  </div>
</div>
